import { render } from "./BuyukSehirImar1000.vue?vue&type=template&id=13323e4a"
import script from "./BuyukSehirImar1000.vue?vue&type=script&lang=js"
export * from "./BuyukSehirImar1000.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__